<template>
  <b-modal v-model="modalVisible" centered hide-footer title="變更清洗狀態">
    <template #default>
      <div>
        <b-form-group
          label="清洗狀態"
        >
          <b-form-select class="w-100" v-model="selectedStatus" :options="statusOpts"></b-form-select>
        </b-form-group>
      </div>

      <div>
        <b-button class="w-100" variant="primary" @click="statusSaveBtnClicked">
          儲存變更
        </b-button>
      </div>

    </template>
  </b-modal>
</template>

<script>
import commonBusyAndErrorHandling from "@/assets/js/commonBusyAndErrorHandling";
export default {
  mixins: [commonBusyAndErrorHandling],
  name: 'KegWashedChangeModal',
  data() {
    return {
      selectedStatus: false,

      statusOpts: [
        {
          text: '未清洗',
          value: false,
        },
        {
          text: '已清洗',
          value: true,
        },
      ],
    };
  },
  components: {
  },
  props: {
    value: {
      type: Boolean,
      required: true,
      default: false,
      passed: false,
    },
    keg: {
      type: Object,
      required: true,
    },
  },
  computed: {
    modalVisible: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      },
    },
    

  },
  watch: {
    modalVisible(val) {
      if (val) {
        this.selectedStatus = this.keg.washed;
      }
    },
  },
  mounted() {
  },
  methods: {
    async statusSaveBtnClicked() {
      try {
        await this.handleAsyncTask(() => this.$store.dispatch('keg/kegUpdateWashed', {kegSerial: this.keg.serial, washed: this.selectedStatus}));
        this.modalVisible = false;
        await this.$bvModal.msgBoxOk('清洗狀態已儲存!');
      } catch (error) {
        console.error(error);
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import "src/assets/scss/basic";

</style>
